import React from "react";
import { AiFillHome } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { Wrapper } from "./BottomBarItem";

interface HomeButtonProps {}

const HomeButton: React.FC<HomeButtonProps> = ({}) => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate("/");
  };
  return (
    <Wrapper onClick={onClick}>
      <AiFillHome color="white" size="1.5em" />
    </Wrapper>
  );
};

export default HomeButton;
